import script from "./CollectionProductHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionProductHistory.vue?vue&type=script&setup=true&lang=js"

import "./CollectionProductHistory.vue?vue&type=style&index=0&id=252302f8&lang=scss"

const __exports__ = script;

export default __exports__